<template>
 <div class="block">
   <img :src="imgString" alt="">
 </div>
</template>

<script>
export default {
  name: 'imgShow',
  props: {
    imgString: String
  }
}
</script>

<style lang='stylus' scoped>
@import '~@/assets/styles/varibles.styl'
.block
  display flex
  flex-direction row
  justify-content center
  align-items center
  position fixed
  left 0
  top 0
  bottom 0
  right 0
  z-index 999999
  background rgba(0,0,0,0.3)
</style>



// WEBPACK FOOTER //
// src/components/imgShow.vue